import React from "react";
import "./ride.css";
import { useTranslation } from "react-i18next";
const Description = () => {
  const { t } = useTranslation();

  return (
    <div className="description flex flex-col items-center lg:w-1/2 m-auto py-5">
      <h1 className="font-extrabold text-4xl mb-2">
        {t("ridePage.ride_service_title")}
      </h1>
      <p className="font-extrabold text-2xl text-[#FABE20]">
        {t("ridePage.ride_service_description")}
      </p>
    </div>
  );
};

export default Description;
